import React, { ReactNode } from "react";

type Props = {
  icon?: ReactNode;
  title: string;
  description?: string;
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
  noPadding?: boolean;
};

export const SectionCard = ({
  icon,
  title,
  description,
  actions,
  children,
  className,
  noPadding,
}: Props) => {
  return (
    <div
      className={`section-card${noPadding ? " section-card--flush" : ""}${
        className ? " " + className : ""
      }`}
    >
      <div className="section-card-header">
        <div className="section-card-header-info">
          {icon && <div className="section-card-icon">{icon}</div>}
          <div className="section-card-heading-text">
            <h2 className="section-card-title">{title}</h2>
            {description && (
              <p className="section-card-description">{description}</p>
            )}
          </div>
        </div>
        {actions && <div className="section-card-actions">{actions}</div>}
      </div>
      {children !== undefined && children !== null && (
        <div className="section-card-content">{children}</div>
      )}
    </div>
  );
};

export default SectionCard;
